import { ReactNode } from "react";

import Flex from "@/components/Flex/Flex";

import styles from "./LabeledSwitch.module.css";


export interface LabeledSwitchProps<T extends ReactNode> {
  options: [T, T];
  selectedOption: T;
  setSelectedOption: (option: T) => void;
  style?: React.CSSProperties;
}

export function LabeledSwitch<T extends ReactNode>(props: LabeledSwitchProps<T>) {
  const { options, selectedOption, setSelectedOption, style } = props;
  return (
    <Flex className={styles.headerToggleContainer} style={style}>
      <button
        className={styles.headerToggleButton + ` ${selectedOption === options[0] ? styles.headerToggleButtonSelected : ""}`}
        onClick={() => setSelectedOption(options[0])}
      >
        <span className={selectedOption === options[0] ? "inverse-strong" : "strong"}>{options[0]}</span>
      </button>
      <button
        className={styles.headerToggleButton + ` ${selectedOption === options[1] ? styles.headerToggleButtonSelected : ""}`}
        onClick={() => setSelectedOption(options[1])}
      >
        <span className={selectedOption === options[1] ? "inverse-strong" : "strong"}>{options[1]}</span>
      </button>
    </Flex>
  );
}
          